import { AlreadyScheduled } from './AlreadyScheduled'
import { Schedule } from './Schedule'
import { ScheduleDateAndTime } from './ScheduleDateAndTime'
import { SendInfo } from './SendInfo'
import { STEPS, type Step } from './steps'
import { WarehouseInstructions } from './WarehouseInstructions'

export function DrawerStep({ step }: { step: Step }) {
  switch (step) {
    case STEPS.INSTRUCTIONS:
      return <WarehouseInstructions />
    case STEPS.SCHEDULE:
      return <Schedule />
    case STEPS.SCHEDULE_DATE_AND_TIME:
      return <ScheduleDateAndTime />
    case STEPS.SEND_INFO:
      return <SendInfo />
    case STEPS.ALREADY_SCHEDULED:
      return <AlreadyScheduled />
    default:
      return null
  }
}
